















































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { SessionManager } from "@/components/utils/utils";
import Spinner from '@/components/utils/Spinner.vue'

import Disclaimer from "../Disclaimer.vue"

import { namespace } from "vuex-class";   
import "@/store/modules/common";
import { loginStatesInfoType, userCredentialsInfoType, userInfoType, userStatesInfoType } from '@/types/Admin';
const commonState = namespace("Common");


import { vehicleTypeOptions } from '../utils/enums';

@Component({
    components:{
        Spinner, 
        Disclaimer,
    }
})
export default class LandingPage extends Vue {
    
    @commonState.State
    public user!: userInfoType;

    confirmEmail = ''
    confirmPassword = ''
    message = '';
    
    disclaimer = {show: false}

    isLoggedIn = false;
    pageReady = false;

    signUp = false;
    signIn = false;

    registering = false;
    authenticating = false;

    credentials = {} as userCredentialsInfoType;
    newUser = {} as userInfoType;  
    vehicleTypeOptions; 

    updateRegisterInfo = 0; 
    updateLoginInfo = 0; 
    
    dismissCountDown =0
    alertType=""

    registerStates = {} as userStatesInfoType;
    loginStates = {} as loginStatesInfoType;

    loginUrl = ''
    
    created() {
        this.vehicleTypeOptions = vehicleTypeOptions;
    }

    async mounted() {
        this.pageReady = false;
        this.registering = false;
        this.authenticating = false;        
        this.message = "";
        this.registerStates = {} as userStatesInfoType;
        this.loginStates = {} as loginStatesInfoType;

        const token = await this.$http.get('/oidc/token');        
        console.log(token.data);
        this.loginUrl = token?.data?.login_url;
        if(token?.data?.access_token)
            this.$store.commit('Common/setToken',token.data.access_token);
        
        this.$store.commit('Common/setLogoutUrl',token.data.logout_url);
        this.$store.commit('Common/setIsKeycloak',token.data.keycloak);

        if(this.$store.state.Common.token)            
            await SessionManager.getUserInfo(this.$store);
        
        if(this.user?.id){
            this.isLoggedIn = true
            this.$router.push({ name: "manage-bookings" });
        }else{
            this.isLoggedIn = false;
            this.pageReady = true;
        } 
    }

    public keycloakLogin() {
        window.location.replace(this.loginUrl);
    }
  
    public login() {         
        this.clearStates();  
        this.signUp = false;
        this.signIn = true;         
    }

    public authenticate() {
        if (this.checkLoginStates()){       
            
            this.message = "";
            this.authenticating = true;

            this.$http.post('/auth/login',this.credentials)
            .then(response =>{
                this.$router.push({ name: "manage-bookings" });
                this.authenticating = false;
            },err =>{
                this.message = err.response.data.detail;
                this.alertType="danger";
                this.dismissCountDown = 3;
                this.authenticating = false;
            });       
        }          
    }

    public register() {      
        this.clearStates();
        this.signIn = false;
        this.signUp = true;                 
    }

    public areTermsAccepted(accept){
        if(accept==true){
            this.registering = true;
            this.$http.post('/user/register',this.newUser)
            .then(response =>{
                this.registering = false;
                this.alertType="success";
                this.dismissCountDown = 3;
                this.message = "You have successfully enrolled in the parking reservation system."
                this.signUp = false;
                this.signIn = true; 
            },err =>{              
                this.message = err.response.data.detail;
                if(err.response.status==409 && err.response?.data?.detail?.split('Key')?.length>1) this.message = err.response.data.detail.split('Key')[1];
                this.alertType="danger";
                this.dismissCountDown = 3;
                this.registering = false;
            });
        }
    }

    public createProfile() {       
        if (this.checkRegisterStates()){
            this.disclaimer.show = true                
        }
    }

    public checkRegisterStates(){

        let stateCheck = true;
    
        this.registerStates.email = !(this.newUser.email)? false : null;
        this.registerStates.confirmEmail = !(this.newUser.email && this.confirmEmail && this.newUser.email == this.confirmEmail)? false : null;        
        this.registerStates.firstName = !(this.newUser.first_name)? false : null;
        this.registerStates.lastName = !(this.newUser.last_name)? false : null;
        this.registerStates.vehicleType = !(this.newUser.vehicle_type)? false : null;
        this.registerStates.licensePlate = !(this.newUser.license_plate)? false : null;
        this.registerStates.password = !(this.newUser.password)? false : null;
        this.registerStates.confirmPassword = !(this.newUser.password && this.confirmPassword && this.newUser.password == this.confirmPassword)? false : null;      
      
        this.updateRegisterInfo ++;
        for(const field of Object.keys(this.registerStates)){
            if(this.registerStates[field]==false)
                stateCheck = false;
        }   
        return stateCheck;            
    }

    public checkLoginStates(){

        let stateCheck = true;
    
        this.loginStates.email = !(this.credentials.email)? false : null;
        this.loginStates.password = !(this.credentials.password)? false : null;      
      
        this.updateLoginInfo ++;
        for(const field of Object.keys(this.loginStates)){
            if(this.loginStates[field]==false)
                stateCheck = false;
        }      

        return stateCheck;            
    }

    public clearStates(){

        for(const field of Object.keys(this.registerStates)){
            this.registerStates[field] = null;                
        }    
        
        for(const field of Object.keys(this.loginStates)){
            this.loginStates[field] = null;                
        }
    }

    public countDownChanged(dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    }
  
}
